// React
import clsx from "clsx";
import { useState, useEffect } from "react";

// MUI
import { Skeleton, TextField } from "@mui/material";

export default function PhoneNumberTextField(props) {
	// States
	const [classes, setClasses] = useState("");
	const [regularBorder, setRegularBorder] = useState(false);

	// Handlers
	const handleChange = (e) => {
		if (typeof e.target?.value !== "undefined") {
			let value = e.target.value;

			if (props.onChange) {
				props.onChange(value);
			}
		}
	};

	const handleKeyDown = (event) => {
		props.onKeyDown && props.onKeyDown(event);
	};

	useEffect(() => {
		if (props.classes) {
			setClasses(props.classes);
		}
		if (props.outlined) {
			setRegularBorder(true);
		}
	}, [props.classes, props.outlined]);

	return (
		<>
			{props.isLoading ? (
				<Skeleton
					variant="rectangular"
					width={props.skeletonWidth || 150}
					height={props.skeletonHeight || 30}
					sx={{ borderRadius: "6px", ...props.sx }}
				/>
			) : (
				<TextField
					fullWidth
					value={props.value}
					variant={props.related ? "outlined" : "standard"}
					title={
						(props.startAdornment ? props.startAdornment : "") + props.value + (props.endAdornment ? props.endAdornment : "")
					}
					placeholder={props.placeholder || ""}
					autoComplete={"off"}
					spellCheck={"false"}
					className={clsx({
						[classes]: true,
						"simple-text-field": true,
						"simple-text-related": props.related,
						"simple-text-editable": props.editable,
						"regular-border": regularBorder,
						"blink-related": props.blink,
						"error-border": props.error,
						"simple-text-disabled": !props.editable || props.readOnly,
						"simple-text-grayed": props.readOnly,
					})}
					disabled={props.disabled || props.readOnly}
					sx={props.sx}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
				/>
			)}
		</>
	);
}
